import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { colors } from "@/constants/colors.jsx";

const timeframes = [
  "Immediately",
  "1-3 Months",
  "3-6 Months",
  "6+ Months"
];

const LoanTimingStep = ({ onNext, initialValue = "" }) => {
  const [selectedTimeframe, setSelectedTimeframe] = useState(initialValue);

  return (
    <div className="flex flex-col min-h-[400px] md:min-h-[450px]">
      <div className="space-y-3 mb-6">
        <div className="text-center space-y-1">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">When do you need financing by?</h2>
          <div className="w-12 h-0.5 mx-auto" style={{ backgroundColor: colors.primary[800] }}></div>
        </div>
      </div>

      <div className="flex-grow">
        <RadioGroup
          value={selectedTimeframe}
          onValueChange={setSelectedTimeframe}
          className="grid grid-cols-1 gap-4 max-w-xl mx-auto"
        >
          {timeframes.map((timeframe) => (
            <div key={timeframe}>
              <RadioGroupItem
                value={timeframe}
                id={timeframe}
                className="peer sr-only"
              />
              <Label
                htmlFor={timeframe}
                className="flex items-center justify-center rounded-lg border-2 border-slate-200 bg-white p-4 md:p-5 cursor-pointer transition-all duration-200 text-base md:text-lg font-medium h-[60px] md:h-[64px] hover:bg-[#1a4a1a]/5 hover:border-[#1a4a1a]/20 peer-data-[state=checked]:border-[#1a4a1a] peer-data-[state=checked]:bg-[#1a4a1a]/5"
              >
                {timeframe}
              </Label>
            </div>
          ))}
        </RadioGroup>
      </div>

      <div className="mt-auto">
        <Button
          className="w-full text-white py-3 md:py-4 text-base md:text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-all"
          disabled={!selectedTimeframe}
          onClick={() => onNext(selectedTimeframe)}
          style={{ 
            backgroundColor: colors.primary[800],
            '&:hover': {
              backgroundColor: `${colors.primary[800]}e6`
            }
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default LoanTimingStep;